export default __webpack_public_path__ + "44a86fbb172ab9f56bd3f095184f3b64.svg";